import isElement from './isElement';

// ----------------------------------------------------------------------------

function isElementFor(...args: any): boolean {
    for (const element of args) {
        if (!isElement(element)) {
            return false;
        }
    }

    return true;
}

// ----------------------------------------------------------------------------

export default isElementFor;
